import angular from 'angular'
import './subscription.service'

angular
  .module('admin.subscription', ['admin.subscription.service'])
  .controller('SubscriptionCtrl', SubscriptionCtrl)

/** @ngInject */
function SubscriptionCtrl($scope, $state, $stateParams, SubscriptionService, UploadService) {
  var vm = this
  vm.items = []
  vm.pathImg = ''
  vm.model = {}
  vm.groups = [
    {
      id: 1,
      name: 'Group 1',
    },
    {
      id: 2,
      name: 'Group 2',
    },
    {
      id: 3,
      name: 'Group 3',
    },
  ]

  vm.levels = [
    {
      id: 1,
      name: 'Bronze',
    },
    {
      id: 2,
      name: 'Silver',
    },
    {
      id: 3,
      name: 'Golden',
    },
  ]

  vm.ages = [
    {
      id: 9,
      name: 'Age 9',
    },
    {
      id: 12,
      name: 'Age 12',
    },
    {
      id: 17,
      name: 'Age 17',
    },
    {
      id: 18,
      name: 'Age 18',
    },
  ]

  function load() {
    var items = SubscriptionService.list() || []
    for (var i = 0; i < items.length; i++) {
      var group = _.find(vm.groups, { id: items[i].g })
      var level = _.find(vm.levels, { id: items[i].l })
      items[i].group = group.name
      items[i].level = level.name
    }
    vm.items = items
  }

  load()

  vm.add = function() {
    vm.model = {
      img: '',
    }
    $('#modalSubscription').modal('show')
  }

  vm.save = function() {
    if (!vm.model.t) {
      swal('Title is required!', '', 'error')
      return
    }
    if (!vm.model.txt) {
      swal('Description is required!', '', 'error')
      return
    }
    if (!vm.model.g) {
      swal('Group is required!', '', 'error')
      return
    }
    if (!vm.model.l) {
      swal('Level is required!', '', 'error')
      return
    }

    if (vm.model.id) {
      SubscriptionService.update(vm.model)
      $('#modalSubscription').modal('hide')
      load()
    } else {
      vm.model.id =
        '_' +
        Math.random()
          .toString(36)
          .substr(2, 9)
      SubscriptionService.add(vm.model)
      $('#modalSubscription').modal('hide')
      load()
    }
  }

  vm.edit = function(item) {
    vm.model = angular.copy(item)
    $('#modalSubscription').modal('show')
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          SubscriptionService.remove(item)
          $state.reload()
        }
      },
    )
  }

  vm.sort = function() {}

  vm.upload = function(item) {
    if (vm.pathImg.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.load = true
    UploadService.save('subscriptions', vm.pathImg, 'img', item.id).then(function(fileName) {
      vm.load = false
      vm.model.img = fileName
    })
  }
}
